export { default as EnquiryDetails } from "./EnquiryDetails";
